import register from '../../../../global/js/registry';
export default register('m-date-range', () => import(/* webpackMode: "lazy" */ './m-date-range.controller'));
